import {
    isRequestArchived,
    type Request,
    RequestType,
    RequestTypeDisplayTextMap,
} from '@strata/react-chat';
import { PayerRequestStatusIndicator } from '@strata/react-status-indicators';

import { Permissions } from 'services/constants';

export const ReadPermissionRequestTypeMap = {
    [Permissions.READ_PAYER_REQUEST_ESCALATION]: RequestType.ESCALATION,
    [Permissions.READ_PAYER_REQUEST_CHANGE]: RequestType.CHANGE,
    [Permissions.READ_PAYER_REQUEST_OTHER]: RequestType.OTHER,
} as const;

export const ArchivedRequestStatuses = [
    PayerRequestStatusIndicator.Statuses.CANCELED,
    PayerRequestStatusIndicator.Statuses.COMPLETED,
] as (typeof PayerRequestStatusIndicator.Statuses)[keyof typeof PayerRequestStatusIndicator.Statuses][];

export const getActionButtonPageTitleLabel = (
    requestDetails: Pick<Request, 'requestType' | 'requestStatus'>,
) =>
    isRequestArchived(requestDetails)
        ? 'Archive'
        : RequestTypeDisplayTextMap[requestDetails.requestType];
